/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Switch_To_Local_PickupInputs */

const en_orders_switch_to_local_pickup = /** @type {(inputs: Orders_Switch_To_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to Local Pickup`)
};

const es_orders_switch_to_local_pickup = /** @type {(inputs: Orders_Switch_To_Local_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar a recogida local`)
};

/**
* | output |
* | --- |
* | "Switch to Local Pickup" |
*
* @param {Orders_Switch_To_Local_PickupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_switch_to_local_pickup = /** @type {((inputs?: Orders_Switch_To_Local_PickupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Switch_To_Local_PickupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_switch_to_local_pickup(inputs)
	return es_orders_switch_to_local_pickup(inputs)
});